import { render, staticRenderFns } from "./ExpandSVG.vue?vue&type=template&id=525d410a&scoped=true"
import script from "./ExpandSVG.vue?vue&type=script&lang=js"
export * from "./ExpandSVG.vue?vue&type=script&lang=js"
import style0 from "./ExpandSVG.vue?vue&type=style&index=0&id=525d410a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d410a",
  null
  
)

export default component.exports